function TokensIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_661_2577)">
                <rect
                    x="1.01807"
                    y="1.20703"
                    width="7.38889"
                    height="7.38889"
                    rx="1.25"
                    fill="inherit"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <rect
                    x="12.1294"
                    y="1.20703"
                    width="7.38889"
                    height="7.38889"
                    rx="1.25"
                    fill="inherit"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <rect
                    x="12.1294"
                    y="12.3184"
                    width="7.38889"
                    height="7.38889"
                    rx="1.25"
                    fill="inherit"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <rect
                    x="1.01807"
                    y="12.3181"
                    width="7.38889"
                    height="7.38889"
                    rx="1.25"
                    fill="inherit"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_661_2577">
                    <rect width="20" height="20" fill="white" transform="translate(0.268066 0.457031)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default TokensIcon;
